export default "/images/login-icon.svg?bf836ca954f6e3357ab9f7c61780f683";